import { createFileRoute } from '@tanstack/react-router';

import { ArchiveScreen } from '../../features/personal/ArchiveScreen';

/**
 * `/personal/archive` = الأرشيف (خطة القسم الشخصي ش7).
 *
 * **تحذير مقيس:** خادم التطوير العامل يولّد ملف المسار الجديد بقالبٍ افتراضي
 * («‏Hello …») إن رآه ناقصًا لحظة الكتابة، فيدهس ما كُتب. ووقع ذلك هنا فعلًا:
 * مرّت البوابات كلها خضراء — القالب TypeScript سليم — ولم يكشفه إلا **تفتيش
 * خرج البناء**. فبعد إنشاء أي ملف مسار: اقرأه، أو ابنِ وابحث عن نصٍّ من شاشتك.
 */
export const Route = createFileRoute('/personal/archive')({ component: ArchiveScreen });
